module.exports = __webpack_public_path__ + "img/sbg0106.ee714cb3.png";